mutation (
  $email: AWSEmail!
  $tenantId: TenantId!
) {
  forgotPassword(
    email: $email
    tenantId: $tenantId
  )
}
